@if (loadingProductImages()) {
	<pdp-carousel-skeleton-loader id="skeleton"></pdp-carousel-skeleton-loader>
} @else {
	<pdp-carousel id="carousel"
		[available]="available()"
		[catalogEntryTypeCode]="catalogEntryTypeCode()"
		[eCode]="product()?.partNumber"
		[productName]="product()?.name"
		[swatchColor]="swatchColor()"
		[imageBadge]="location() === 'hybrid_pla' ? undefined : product()?.badge"
		[lazyLoadImage]="lazyLoadImage()"
		[customizedUrls]="hasColorQueryParams() && customizedUrls()"
		[shouldShowOutOfStockRecs]="false"
		[shouldHaveBorder]="shouldHaveBorder()"
		[mediaSetResponse]="mediaSet()"
		[isHybridPLA]="location() === 'hybrid_pla'"
		[hybridPLALinkTarget]="hybridPLALinkTarget()"
	></pdp-carousel>
}
